export const getAccountPage = (baseUrl: string): string => `${baseUrl}/secure/accounts/transfer`
export const getFavouritesPage = (baseUrl: string): string => `${baseUrl}/favourites`
export const getRegisterPage = (baseUrl: string): string => `${baseUrl}/secure/accounts/register`
